import * as React from 'react'
import { UpdateMessageEditorConnected } from './UpdateMessageEditorConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore, MOCK_MESSAGE_A_ID } from 'mockState'

export const UpdateMessageEditorExamples = () => {
  return (
    <div className="UpdateMessageEditorExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <UpdateMessageEditorConnected messageId={MOCK_MESSAGE_A_ID} />
      </Provider>
    </div>
  )
}
